app.controller("SelectGroupController", [
    "$scope", "Socket", "Selection", "student", "subject", "Session", "StaticData", "$stateParams", "$uibModal", "ConfirmModal", "$uibModalInstance",
    function ($scope, Socket, Selection, student, subject, Session, StaticData, $stateParams, $uibModal, ConfirmModal, $uibModalInstance) {
        $scope.selections = {};

        StaticData.getItemsByKey("days").then(function (days) {
            $scope.days = days;
            $scope.daysMap = _.keyBy($scope.days, 'id');
        });

        var activationId = subject.activation._id;

        var fetchActivation = function () {
            Selection.getActivation(activationId).then(function (activation) {
                $scope.activation = activation;
            });
        };

        var fetchSelections = function () {
            Selection.selectionsByActivation(activationId).then(function (data) {
                $scope.selections = data
            });
        };

        var fetchSessions = function () {
            Session.groupList(activationId).then(function (data) {
                _(data).each(function (group) {
                    group.days = _(group.sessions).map('dayOfWeek').map(function (day) {
                        return $scope.daysMap[day].name;
                    }).uniq().value().join(', ');
                });
                $scope.sessions = _.groupBy(data, 'sessionType');
            });
        };

       fetchSelections();
       fetchActivation();
       fetchSessions();

        $scope.choose = function () {
            Selection.addSelection({
                student: student._id,
                subjectActivation: subject.activation
            }).then(function (selection) {
                $scope.selection = selection;
                Selection.prove({
                    selection: selection._id,
                    seminar: selection.subjectSessionGroups[1],
                    lecture: selection.subjectSessionGroups[0]
                }).then(function ( ) {
                    $uibModalInstance.close()
                })
            });
        };

        $scope.close = function () {
            $uibModalInstance.dismiss();
        };
    }
]);